<ng-container class="p-2 mb-2 pt-3" [ngSwitch]="route.snapshot.queryParams['oem']">
  <quorum-gm-vehicle-diagnostics *ngSwitchCase="'GM'"></quorum-gm-vehicle-diagnostics>
  <!-- <quorum-ford-vehicle-diagnostics *ngSwitchCase="'FO'"></quorum-gm-vehicle-diagnostics>
  <quorum-toyota-vehicle-diagnostics *ngSwitchCase="'TOY'"></quorum-toyota-vehicle-diagnostics>
  <quorum-chrysler-vehicle-diagnostics *ngSwitchCase="'CH'"></quorum-chrysler-vehicle-diagnostics>
  <quorum-nissan-vehicle-diagnostics *ngSwitchCase="'NIS'"></quorum-nissan-vehicle-diagnostics>
  <quorum-hyundai-vehicle-diagnostics *ngSwitchCase="'HYU'"></quorum-hyundai-vehicle-diagnostics> -->
  <quorum-vehicle-diagnostics *ngSwitchDefault [oem]="route.snapshot.queryParams['oem']"></quorum-vehicle-diagnostics>
</ng-container>